import { ChangeDetectorRef, Component, inject, input, OnInit, afterEveryRender } from '@angular/core';
import { IDocumentType, ISection } from '../../../../core/models/documents.model';
import { GetCountryDocuments } from '../../../../core/services/get-country-documents';
import { IExternalCountryDetails } from '../../../../core/models/external-country.model';
import {DayTime} from '../../../client-service/day-time/day-time'

import { StateService } from '../../../../core/services/state.service';
import { computed } from '@angular/core';

@Component({
    selector: 'app-business',
    imports: [],
    templateUrl: './business.html',
    styleUrl: './business.scss',
})
export class Business implements OnInit {
    sectionsRows = input.required<ISection[][]>();
    children = input.required<IDocumentType[]>();
    sidebarSectionInput = input<ISection | null>(null, { alias: 'sidebarSection' });

    private stateService = inject(StateService);
    readonly sidebarSection = computed(() => this.sidebarSectionInput() || this.stateService.sidebarSection());

    private getCountryDocsService = inject(GetCountryDocuments);
    private cdr = inject(ChangeDetectorRef);
    externalCountryDetails: IExternalCountryDetails | null = null;

    constructor() { 
        afterEveryRender(() =>{
            this.updatetime()
        })
    }

    async ngOnInit() {
        let linkIndex = 0;
        this.sectionsRows().map((row: ISection[]) => {
            row.forEach((section: ISection) => {
                if (section.content && section.content.includes("$linkChildren")) {

                    if (this.children() && this.children()[linkIndex]) {
                        let myPAth = this.children()![linkIndex].slug.replaceAll("_", "/")
                        section.content = section.content.replaceAll("$linkChildren", myPAth)
                    }
                    linkIndex += 1
                }
            });
        });

        try {
            this.externalCountryDetails = await this.getCountryDocsService.getExternalCountry(1);

            if (this.externalCountryDetails) {
                console.log(this.externalCountryDetails);
                
                const dotNetCountryId = this.externalCountryDetails.dotNetCountryId;
                const priceRegex = /#id=(\d+)/;

                for (const row of this.sectionsRows()) {
                    for (const section of row) {
                        const match = section.content.match(priceRegex);
                        if (match) {
                            const id = parseInt(match[1], 10);

                            let foundDocument = this.externalCountryDetails.external_documents.find((doc) => doc.Id === id);

                            if (foundDocument) {
                                section.content = section.content.replace(
                                    /#id=\d+\n?/,
                                    ''
                                );
                                let TotalFee = 0
                                let totalTime = 0

                                const servicesList = foundDocument.Services?.services || foundDocument.services?.services || [];
                                servicesList.forEach((service) => {
                                    TotalFee += service.ExpeditedOptions == null ? service.Fee : (service.Fee + service.ExpeditedOptions.UsingExpeditedFees)
                                    totalTime += service.ExpeditedOptions == null ? service.Time : service.ExpeditedOptions.ExpeditedWorkingDays
                                });
                                section.content = section.content.replace(`#totalPrice`, `$${TotalFee}`)
                                section.content = section.content.replace(`#totalDays`, `<span class="hereAddTime ${totalTime}">${totalTime} Business Days</span>`)

                            }

                        }
                    }
                }
                this.cdr.detectChanges();
            }
        } catch (error) {
            console.error('[Business] Failed to retrieve external country details:', error);
        }


    
        
    }

    updatetime(){
        if (typeof document === 'undefined') return;
        const spans = document.querySelectorAll('.hereAddTime') as NodeListOf<HTMLElement>;        
        spans.forEach((span: HTMLElement) => {
            const classList = span.getAttribute('class');
            const time = classList?.split(' ')[1]; 

        });
    }

    parseFaq(content: any): any[] {
        if (!content) return [];
        if (Array.isArray(content)) return content;
        try {
            let parsed = typeof content === 'string' ? JSON.parse(content) : content;
            if (typeof parsed === 'string') {
                parsed = JSON.parse(parsed);
            }
            return Array.isArray(parsed) ? parsed : [];
        } catch (e) {
            console.error('Error parsing FAQ content:', e);
            return [];
        }
    }
}
